var $ = require("jquery");

$(function () {
    $(".ws-nav-tabs__link").click(function() {
        toggleClasses($(this));
    });
});
function toggleClasses($el) {
    $el.closest(".nav-tabs").find(".ws-nav-tabs__tab").removeClass("active");
    $el.closest(".ws-nav-tabs__tab").addClass("active");
}